import { render, staticRenderFns } from "./FormConfiguration.vue?vue&type=template&id=2b03f94f&scoped=true&"
import script from "./FormConfiguration.vue?vue&type=script&lang=js&"
export * from "./FormConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b03f94f",
  null
  
)

export default component.exports